import { ReactElement } from 'react';
import { className, getColorVariantClassname } from '../../../shared/helpers';
import styles from './IndicatorSemaphore.module.scss';

interface IndicatorSemaphoreProps
{
    status: number;
    score: number;
    hideScore?: boolean;
    customClass?: string;
}

const IndicatorSemaphore = (props: IndicatorSemaphoreProps): ReactElement =>
{
    return (
        <span {...className(styles.wrapper, props.customClass, { [styles.scoreIsHidden]: props.hideScore })}>
            {!props.status ? (
                <>
                    <span className={styles.score}>offline</span>
                    <span {...className(styles.dot, "offline")} />
                </>
            ) : (
                <>
                    <span className="score">{(props.score * 100).toFixed(0)}%</span>
                    <span {...className(styles.dot, getColorVariantClassname(props.status))} />
                </>
            )}
        </span>
    );
};

export default IndicatorSemaphore;